
import React from 'react'
import "./Button.sass"

const Button = ({ text, onClick }) => (
  <button className="button" onClick={onClick} type="button">{text}</button>
)

export default Button;